<template>
    <app-dashboard-tiles :title="title" :legend-title="legendTitle" chart-classes="w-full h-64">
        <template v-slot:chart>
            <line-chart :data="data" :options="options" />
        </template>
        <template v-slot:legendFooter>
            <slot name="legendFooter"></slot>
        </template>
        <template v-slot:icon>
            <slot name="icon"></slot>
        </template>
    </app-dashboard-tiles>
</template>
<script>
import AppDashboardTiles from '@/components/app-dashboard-tiles/AppDashboardTiles.vue';
import { Line } from 'vue-chartjs';

const LineChart = {
    extends: Line,
    props: ['chartData', 'options'],
};
export default {
    components: { AppDashboardTiles, LineChart },
    props: {
        title: { type: String, default: () => '' },
        legendTitle: { type: String, default: () => '' },
        data: { type: Object, default: () => [] },
        options: {
            type: Object,
            default: () => ({
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    },
                    datalabels: {
                        display: false,
                    },
                },
            }),
        },
    },
};
</script>
